var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.595 19.006h-.028a15.33 15.33 0 0 1-10.272-4.298 15.313 15.313 0 0 1-4.3-10.267 2 2 0 0 1 .586-1.436L4.295.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414L8.113 7.3a7.5 7.5 0 0 0 1.594 2.992 7.484 7.484 0 0 0 2.988 1.595l1.6-1.594a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-2.714 2.713c-.37.374-.874.585-1.4.586ZM5 2.415h-.005l-2 2.004a13.245 13.245 0 0 0 3.712 8.874 13.251 13.251 0 0 0 8.873 3.712L17.587 15l-2.592-2.585-1.293 1.292a.987.987 0 0 1-.909.271 10.2 10.2 0 0 1-4.5-2.271 10.2 10.2 0 0 1-2.271-4.5 1 1 0 0 1 .273-.914L7.587 5 5 2.415Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b40eb2c086f73ae70875a7c7b1466aff.svg";
export { ForwardRef as ReactComponent };